import React, { useEffect, useRef } from 'react';
import './QuestsPopup.css';
import gsap from 'gsap';
import rockBg from '../../asserts/rockbg.png';
import Btn3 from '../common/Btn3';

const quests = [
  'Complete the puzzle to win the heart fragment.',
  'Return the fragment to the shop man to unlock Level 2.',
  'Finish the trial without losing any Scarab Coins.',
];

const QuestsPopup = ({ onClose }) => {
  const scrollRef = useRef();
  const contentRef = useRef();

  useEffect(() => {
    gsap.set(scrollRef.current, {
      rotation: 60,
      rotationX: -40,
      opacity: 0,
      transformOrigin: 'center center',
      transformPerspective: 1400,
      x: 100,
      y: 820,
      scale: 0.8,
    });

    const tl = gsap.timeline();
    tl.to(scrollRef.current, {
      rotation: 0,
      rotationX: 0,
      opacity: 1,
      x: 0,
      y: 0,
      scale: 1,
      duration: 1.3,
      ease: 'power3.out',
    }).fromTo(
      contentRef.current.querySelectorAll('.popup-animate'),
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, duration: 0.6, stagger: 0.12, ease: 'power2.out' },
      '-=0.4'
    );
  }, []);

  const handleClose = () => {
    const tl = gsap.timeline({ onComplete: onClose });
    tl.to(contentRef.current.querySelectorAll('.popup-animate'), {
      opacity: 0,
      y: 20,
      duration: 0.25,
      stagger: 0.06,
      ease: 'power2.in',
    }).to(scrollRef.current, {
      rotation: -20,
      rotationX: 40,
      opacity: 0,
      x: -200,
      y: 120,
      scale: 0.8,
      duration: 1,
      ease: 'power3.in',
    }, '-=0.1');
  };

  return (
    <div className="popup-overlay">
      <div className="popup-scroll" ref={scrollRef} style={{ backgroundImage: `url(${rockBg})` }}>
        <div className="popup-inner" ref={contentRef}>
          <h2 className="popup-title popup-animate">Quests</h2>
          <div className="quests-list">
            {quests.map((q, i) => (
              <div key={i} className="quest-item popup-animate">
                <div className="quest-checkbox" />
                <span className="quest-text">{q}</span>
              </div>
            ))}
          </div>
          <div className="popup-back popup-animate">
            <Btn3 onClick={handleClose} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestsPopup;